import { jsx as _jsx } from "preact/jsx-runtime";
// Re-export the existing CompanyManagement component for Settings/Company
import { CompanyManagement } from './company/CompanyManagement';
export function SettingsCompany({ onNavigateHome }) {
    return _jsx(CompanyManagement, { onNavigateHome: onNavigateHome });
}
